import React from 'react';
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import emptyPublisherLogo from "../../../img/empty-publisher-logo.png";
import {Colors} from "../../../theme/colors";
import {Link} from "react-router-dom";
import {CustomArrowRightIcon} from "../../ui-base/icons/custom-arrow-right-icon";
import {CustomLinearProgress} from "../../custom-linear-progress/custom-linear-progress";
import {PublisherApplicationModel} from "../../../models/publisher/publisher-application.model";
import {ApplicationStatusTranslateEnum} from "../../../models/application-status-translate.enum";
import {useTranslation} from "react-i18next";

export const ApplicationShort: React.FC<{application: PublisherApplicationModel}> = ({application}) => {
    const { t } = useTranslation(['author', 'common']);

    const getStatusColor = (status: string) => {
        if (status === 'PubNotWant' || status === 'AutNotWant' || status === 'Failed') {
            return 'red';
        } if (status === 'Submitted' || status === 'OpenByPub' || status === 'ContDownl' || status === 'RepDownl') {
            return 'yellow';
        } else {
            return 'green';
        }
    }

    const getProgressByStatus = (status: string) => {
        if (status === 'Submitted' || status === 'OpenByPub') {
            return 25;
        } else if (status === 'ContDownl' || status === 'RepDownl') {
            return 50;
        } else if (status === 'PubWant') {
            return 75;
        } else {
            return 100;
        }
    }

    const getCssStatusColor = (status: string) => {
        if (status === 'PubNotWant' || status === 'AutNotWant' || status === 'Failed') {
            return Colors.red;
        } if (status === 'Submitted' || status === 'OpenByPub' || status === 'ContDownl' || status === 'RepDownl') {
            return Colors.yellow;
        } else {
            return Colors.green;
        }
    }

    return (
        <Grid className="application-short" item sm={12} md={6} lg={3}>
            <StyledContainer item container direction={'column'}>
                <Grid item container justifyContent={"center"}>
                    <StyledImg src={emptyPublisherLogo}/>
                </Grid>

                <Grid item>
                    <StyledPublisherName>{application.publisher.name}</StyledPublisherName>
                </Grid>

                <Grid item>
                    <StyledTitle>{application.manuscript.title}</StyledTitle>
                </Grid>

                <Grid item>
                    <StyledDate>{t('applicationShort.updated')}: {new Date(application.updated).toLocaleString()}</StyledDate>
                </Grid>

                <Grid item>
                    <StyledStatus>{t('applicationShort.status')} <span className={getStatusColor(application.status)}>{t(`common:applicationStatus.status${application.status}`)}</span></StyledStatus>
                </Grid>

                <Grid item>
                    <CustomLinearProgress
                        value={getProgressByStatus(application.status)}
                        color={getCssStatusColor(application.status)}
                    />
                </Grid>

                <Grid item style={{marginTop: '30px'}}>
                    <StyledProfileLink to={'/author/book/' + application.manuscript.id}>
                        {t('common:showDetails')}
                        <CustomArrowRightIcon style={{width: '12px', height: '10px', marginLeft: '5px'}}/>
                    </StyledProfileLink>
                </Grid>
            </StyledContainer>
        </Grid>
    );
}

const StyledContainer = styled(Grid)`
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  padding: 0 20px 20px;
  height: 100%;
`;

const StyledImg = styled('img')`
  height: 135px;
  padding: 24px 0 12px;
  object-fit: contain;
`;

const StyledTitle = styled('h6')`
  color: ${Colors.violet};
  font-size: 1.3rem;
  margin-top: 1rem;
`;

const StyledPublisherName = styled('p')`
  font-size: 0.9rem;
  color: ${Colors.grayText};
  font-weight: 500;
  text-align: center;
`;

const StyledDate = styled('p')`
  font-size: 0.9rem;
  color: ${Colors.grayText};
  font-weight: 400;
`;

const StyledStatus = styled('p')`
  font-size: 0.9rem;
  font-weight: 500;
  padding: 20px 0 15px;
  
  span {
    font-size: 0.8rem;
    padding: 2px 5px;
    border-radius: 10px;
    margin-left: 5px;

    &.green {
      border: 1px solid #B3DAC7;
      background-color: #EBF5F0;
      color: ${Colors.green};
    }

    &.red {
      background-color: #FFECEC;
      border: 1px solid #FFD7D7;
      color: ${Colors.dangerRedHover};
    }

    &.yellow {
      background-color: #FFF2E7;
      border: 1px solid #FFCA99;
      color: #653508;
    }
  }
`;

const StyledProfileLink = styled(Link)`
  color: ${Colors.lightViolet};
  font-weight: 500;
`;

